<clr-dropdown [clrCloseMenuOnItemClick]="false">
  <button class="btn btn-outline-primary" clrDropdownTrigger>
    Rôle*
    <cds-icon shape="angle" direction="down"></cds-icon>
  </button>
  <clr-dropdown-menu>
    @for (item of items; track item) {
      <div clrDropdownItem>
        <clr-checkbox-wrapper>
          <input type="checkbox" clrCheckbox (click)="selectItem(item)" /><label>{{
          item.name
        }}</label>
      </clr-checkbox-wrapper>
    </div>
  }
</clr-dropdown-menu>
</clr-dropdown>
